<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<div class="dash">
  <div class="trip-acoordion">
    <div class="dash-trucks-top1">
      <a
        [ngClass]="{ active: tripType == '-1' }"
        (click)="getTripsList('-1')"
        (click)="GoToAllTrips()"
        >All Trips</a
      >
      <a
        [ngClass]="{ active: tripType == 'upComing' }"
        (click)="getTripsList('upComing')"
        >UpComing</a
      >
      <a
        [ngClass]="{ active: tripType == 'liveTrips' }"
        (click)="getTripsList('liveTrips')"
        (click)="GoToLiveTrips()"
        >Live Trips</a
      >
      <a
        [ngClass]="{ active: tripType == 'completed' }"
        (click)="getTripsList('completed')"
        >Completed</a
      >
      <a
        [ngClass]="{ active: tripType == 'cancelled' }"
        (click)="getTripsList('cancelled')"
        >Cancelled</a
      >
      <a
        [ngClass]="{ active: tripType == 'quotes' }"
        (click)="getTripsList('quotes')"
        >Quotes</a
      >
      <a
        [ngClass]="{ active: tripType == 'quoteBooked' }"
        (click)="getTripsList('quoteBooked')"
      >
        Quote Booked
      </a>
      <a
        [ngClass]="{ active: tripType == 'quoteCancel' }"
        (click)="getTripsList('quoteCancel')"
      >
        Cancelled Quote
      </a>
    </div>

    <div class="dash-trucks-top2">
      <button
        type="button"
        *ngIf="searchButton"
        class="button search-btn fixed-btn"
        (click)="openSearch()"
      >
        <img src="../../../assets/img/search-white.svg" />
      </button>
      <div *ngIf="toggleSearch" class="search_toggle">
        <input
          uppercase
          class="search"
          placeholder="Trip ID"
          id="searchtripID"
          #newItem
          (keyup)="onInputChange(newItem)"
          (keyup.enter)="isInputValid && search(newItem.value)"
        />
        <button
          [disabled]="!isInputValid"
          *ngIf="search_Btn"
          class="search_number"
          (click)="search(newItem.value)"
        >
          <img src="../../../assets/img/search-white.svg" />
        </button>
        <button
          type="button"
          class="search_number1"
          *ngIf="cancelButton"
          (click)="cancel()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
          >
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div class="trucks">
    <div [class.spinner]="loading"></div>

    <div class="row to_container" *ngIf="!tripsArray?.length && !loading">
      <h4 class="error_msg">No Records Found.</h4>
    </div>
    <div class="row" *ngIf="allTrips">
      <div class="col-md-3 mb-3" *ngFor="let item of tripsArray; let i = index">
        <div class="truckscol">
          <div class="trips">
            <p
              class="ticket"
              matTooltip="View Trip Details"
              matTooltipPosition="above"
              (click)="viewTrips(item)"
            >
              {{ item.trip_id }}
            </p>
            <a class="notes" (click)="addNotes(item._id)">Add Notes</a>
            <img
              matTooltip="Retail Notification by Drivers"
              matTooltipPosition="above"
              src="../../../assets/img/lorry.svg"
              *ngIf="
                item.trip_status != 'completed' &&
                item.trip_status != 'cancelled' &&
                item.trip_status != 'inprogress' &&
                item.trip_status != 'quoteCancel' &&
                item.trip_status != 'tripstarted' &&
                item.trip_status != 'tripbooked' &&
                item.trip_status != 'quoteBooked'
              "
              class="takeimg"
              (click)="retailNotifyDriver(item)"
            />
            

            <img
              matTooltip="Corporate Edit Trips"
              matTooltipPosition="above"
              src="../../../assets/img/admin-edit.svg"
              *ngIf="
                item.trip_status != 'cancelled' &&
                item.trip_status != 'quote' &&
                item.trip_status != 'quoteCancel' &&
                item.trip_status != 'quoteBooked' &&
                item.userInfo[0]?.user_type == 'corporate'
              "
              class="img1"
              (click)="editTrips(item)"
            />
            
            <img
              matTooltip="Retail Customer Edit Trips"
              matTooltipPosition="above"
              src="../../../assets/img/admin-edit.svg"
              *ngIf="
                item.trip_status != 'cancelled' &&
                item.trip_status != 'quote' &&
                item.trip_status != 'quoteCancel' &&
                item.trip_status != 'quoteBooked' &&
                item.userInfo[0]?.user_type != 'corporate'
              "
              class="img1"
              (click)="editTripsRetail(item)"
            />
            <mat-icon
            matTooltip="Generate Invoice"
              matTooltipPosition="above"
              *ngIf="item.trip_status == 'completed'"
              class="img1"
              (click)="openInvoiceDialog(item)">description
            </mat-icon>
            <!-- <img
              matTooltip="Generate Invoice"
              matTooltipPosition="above"
              src="../../../assets/img/invoice.svg"
              *ngIf="item.trip_status == 'completed'"
              class="img1"
              (click)="openInvoiceDialog(item)"
            /> -->

            <img
              matTooltip="Retail Quote Edit Trips"
              matTooltipPosition="above"
              src="../../../assets/img/admin-edit.svg"
              *ngIf="
                item.trip_status === 'quote' ||
                item.trip_status === 'quoteBooked'
              "
              class="img1"
              (click)="retailEditTrips(item)"
            />

            <img
              matTooltip="Truck Owner Payment"
              matTooltipPosition="above"
              src="../../../assets/img/payment_icon.png"
              *ngIf="
                item.trip_status != 'quoteCancel' &&
                item.trip_status != 'quote' &&
                item.trip_status != 'cancelled' &&
                (item?.paymentInfo?.length !== 0 || item?.userInfo?.[0]?.user_type === 'corporate')
              "
              (click)="tripPayment(item)"
              class="editimg"
            />
          </div>

          <div class="payment-container">
            <div class="location-payment">
              <!-- <img src="../../../assets/img/location-payment.svg" alt="" /> -->
              <img
                [src]="item.stops?.length > 0
                        ? '../../../assets/img/location-payment-stop.svg' 
                        : '../../../assets/img/location-payment.svg'"
                [matTooltip]="item.stops?.length > 0 ? ('Stops: ' + item.stops.length) : ''"
                [matTooltipDisabled]="!(item.stops?.length > 0)"
                matTooltipPosition="right"
                alt=""
              />
              <span class="places">
                <span>{{ item.pickup_details.from_city_name }}</span>

                <p
                  class="button cancel-btn ms-2"
                  *ngIf="
                    item.trip_status != 'completed' &&
                    item.trip_status != 'quote' &&
                    item.trip_status != 'quoteCancel' &&
                    item.trip_status != 'quoteBooked' &&
                    item.trip_status != 'cancelled'
                  "
                  (click)="cancelTrip(item)"
                >
                  {{ convertCamelToNormalCase(item.trip_status) }}
                </p>
                <p
                  class="button cancel-btn ms-2"
                  *ngIf="
                    item.trip_status == 'completed' ||
                    item.trip_status == 'quote' ||
                    item.trip_status == 'quoteCancel' ||
                    item.trip_status == 'quoteBooked' ||
                    item.trip_status == 'cancelled'
                  "
                >
                  {{ convertCamelToNormalCase(item.trip_status) }}
                </p>
                
                <span>{{ item.dropoff_details.to_city_name }}</span>
              </span>
            </div>
            <div
              class="payment"
              *ngIf="item.userInfo[0]?.user_type != 'corporate'"
            >
              <div class="amount">Total Amount</div>
              <div class="amount">
                ₹
                {{
                  (
                    item.paymentInfo[0]?.price_details.total_amount || 0
                  ).toFixed(2)
                }}
              </div>
              <div class="tax">Inc.Taxes</div>
            </div>

            <div
              class="payment"
              *ngIf="
                item.trip_status === 'completed' &&
                item.userInfo[0]?.user_type === 'corporate' &&
                !item.paymentInfo[0]?.payment_id
              "
            >
              <div class="amount">Total Amount</div>
              <div
                class="amount"
                *ngIf="
                  item.workOrderInfo[0]?.pay_as_load_quantity ===
                  'loaded_quantity'
                "
              >
                ₹
                {{
                  (
                    item?.workOrderOtherDetails?.loading_point *
                      item?.workOrderOtherDetails?.price_per_ton || 0
                  ).toFixed(2)
                }}
              </div>
              <div
                class="amount"
                *ngIf="
                  item.workOrderInfo[0]?.pay_as_load_quantity ===
                  'unloaded_quantity'
                "
              >
                ₹
                {{
                  (
                    (item?.workOrderOtherDetails?.unloading_point
                      ? item?.workOrderOtherDetails?.unloading_point * item?.workOrderOtherDetails?.price_per_ton
                      : item?.workOrderOtherDetails?.loading_point * item?.workOrderOtherDetails?.price_per_ton) || 0
                  ).toFixed(2)
                }}
              </div>
            </div>
          </div>

          <div class="details">
            <p class="truck-date">
              Truck No: {{ item?.truckInfo[0]?.truck_number }}
            </p>
            <p class="truck-detail">
              ({{ item?.truckTypeInfo[0]?.truck_weight }}
              {{ item?.truckCatInfo[0]?.truck_category_name }}
              {{ item?.truckTypeInfo[0]?.truck_feet }})
            </p>
            <p
              class="truck-date"
              *ngIf="item?.userInfo?.length === 0 || item?.userInfo[0]?.user_type === 'customer'"
            >
              Customer Contact:
              {{ item.userInfo ? item.userInfo[0]?.mobile : "" }}
            </p>
            <p
              class="truck-date"
              *ngIf="item?.userInfo[0]?.user_type === 'corporate'"
            >
              Corporate Contact:
              {{ item.userInfo ? item.userInfo[0]?.mobile : "" }}
            </p>
            <p class="truck-date">
              Driver Contact:
              {{ item.driverInfo ? item.driverInfo[0]?.mobile : "" }}
            </p>
            <p class="truck-date">
              Truck Owner:
              {{ item.truckownerInfo ? item.truckownerInfo[0]?.mobile : "" }}
            </p>
          </div>

          <div
            class="col-footer"
            *ngIf="
              ((item.trip_status === 'tripstarted' || item.trip_status === 'tripbooked') &&
                item.userInfo[0]?.user_type === 'customer' &&
                item?.paymentInfo[item?.paymentInfo?.length - 1]
                  ?.payment_status === 'fully-paid') ||
              (item.trip_status === 'inprogress' &&
                item.userInfo[0]?.user_type === 'customer') ||
              (item.trip_status === 'completed' &&
                item.userInfo[0]?.user_type === 'customer')
            "
          >
            <div
              class="side1"
              *ngIf="
                item.paymentInfo[0]?.price_details?.total_amount ==
                item.paymentInfo[0]?.price_details?.payment_history[1]
                  ?.amount_paid +
                  item.paymentInfo[0]?.price_details?.payment_history[2]
                    ?.amount_paid
              "
            >
              <h3>Received (100%):</h3>
              <p>
                ₹
                {{
                  (
                    (item.paymentInfo[0]?.price_details?.payment_history[1]
                      ?.amount_paid || 0) +
                    (item.paymentInfo[0]?.price_details?.payment_history[2]
                      ?.amount_paid || 0)
                  ).toFixed(2)
                }}
              </p>
            </div>
            <div
              class="side1"
              *ngIf="
                item.paymentInfo[0]?.price_details?.total_amount !=
                item.paymentInfo[0]?.price_details?.payment_history[1]
                  ?.amount_paid +
                  item.paymentInfo[0]?.price_details?.payment_history[2]
                    ?.amount_paid
              "
            >
              <h3>Received</h3>
              <p>
                ₹
                {{
                  (
                    item.paymentInfo[0]?.price_details?.payment_history[1]
                      ?.amount_paid ??
                    item.paymentInfo[0]?.price_details?.payment_history[2]
                      ?.amount_paid ??
                    0
                  ).toFixed(2)
                }}
              </p>
            </div>
            <div class="side1">
              <h3 (click)="consignment(item)">Consignment Note</h3>
            </div>
          </div>

          <div
            class="col-footer"
            *ngIf="
              item.trip_status === 'completed' &&
              item.userInfo[0]?.user_type === 'corporate' &&
              !item.paymentInfo[0]?.payment_id
            "
          >
            <div class="side2">
              <h3>Trip Completed from Corporate</h3>
            </div>
          </div>
          <div
            class="col-footer"
            *ngIf="
              item.trip_status === 'cancelled' &&
              item.userInfo[0]?.user_type === 'corporate' &&
              !item.paymentInfo[0]?.payment_id
            "
          >
            <div class="side2">
              <h3>Trip Cancelled from Corporate</h3>
            </div>
          </div>
          <div
            class="col-footer"
            *ngIf="
              item.trip_status === 'completed' &&
              item.paymentInfo[0]?.payment_id &&
              item.userInfo[0]?.user_type != 'customer'
            "
          >
            <div class="side2">
              <h3>Trip Completed from Customer</h3>
            </div>
          </div>

          <div
            class="col-footer"
            *ngIf="
              (item.userInfo[0]?.user_type === 'corporate' &&
                item.trip_status === 'quote') ||
              (item.userInfo[0]?.user_type === 'corporate' &&
                item.trip_status === 'quoteBooked') ||
              (item.userInfo[0]?.user_type === 'corporate' &&
                item.trip_status === 'quoteCancel') ||
              (item.userInfo[0]?.user_type === 'corporate' &&
                item.trip_status === 'tripstarted') ||
              (item.userInfo[0]?.user_type === 'corporate' &&
                item.trip_status === 'tripbooked') ||
              (item.userInfo[0]?.user_type === 'corporate' &&
                item.trip_status === 'inprogress')
            "
          >
            <div class="side2">
              <h3>Trip From Corporate</h3>
            </div>
          </div>

          <div
            class="col-footer"
            *ngIf="
              item.userInfo[0]?.user_type === 'customer' &&
                  item?.paymentInfo[item?.paymentInfo.length - 1]?.payment_status === 'partial-paid' &&
              (
                item.trip_status === 'tripbooked' ||
                (item.trip_status === 'tripstarted' )
              )
            "
          >
            <div class="side1">
              <h3>Received (10%)</h3>
              <p>
                ₹
                {{
                  (
                    item.paymentInfo[0]?.price_details?.payment_history[1]
                      ?.amount_paid || 0
                  ).toFixed(2)
                }}
              </p>
            </div>
            <div class="side1">
              <h3>Balance (90%)</h3>
              <p>
                ₹
                {{
                  (
                    item.paymentInfo[0]?.price_details?.total_amount -
                      item.paymentInfo[0]?.price_details?.amount_paid || 0
                  ).toFixed(2)
                }}
              </p>
            </div>
          </div>
          <div
            class="col-footer"
            *ngIf="
              (item.userInfo[0]?.user_type === 'customer' &&
                item?.paymentInfo.length === 0) ||
              (item?.paymentInfo[0]?.payment_status === 'not-paid' &&
                item.trip_status != 'quote' &&
                item?.paymentInfo.length > 0)
            "
          >
            <div class="side2">
              <h3>Payment Not Done</h3>
            </div>
          </div>
          
          <div class="col-footer" *ngIf="item.userInfo?.length === 0">
            <div class="side2">
              <h3>Customer Deleted</h3>
            </div>
          </div>

          <div
            class="col-footer"
            *ngIf="
              item.trip_status == 'cancelled' &&
              item.paymentInfo[0]?.payment_status === 'refunded'
            "
          >
            <div class="side1">
              <h3>Actual Refund</h3>
              <p>
                ₹
                {{
                  (
                    item.paymentInfo[0]?.price_details?.amount_paid || 0
                  ).toFixed(2)
                }}
              </p>
            </div>
            <div
              class="side1"
              *ngIf="
                item.paymentInfo[0]?.payment_status === 'refunded' &&
                item.paymentInfo[0]?.cancelled_trip_payment_info
                  ?.payment_type === 'Fully-Refund'
              "
            >
              <h3>Fully Refund</h3>
              <p>
                ₹
                {{
                  (
                    item.paymentInfo[0]?.cancelled_trip_payment_info
                      ?.amount_paid || 0
                  ).toFixed(2)
                }}
              </p>
            </div>
            <div
              class="side1"
              *ngIf="
                item.paymentInfo[0]?.payment_status === 'refunded' &&
                item.paymentInfo[0]?.cancelled_trip_payment_info
                  ?.payment_type === 'Partial-Refund'
              "
            >
              <h3>Partial Refund</h3>
              <p>
                ₹
                {{
                  (
                    item.paymentInfo[0]?.cancelled_trip_payment_info
                      ?.amount_paid || 0
                  ).toFixed(2)
                }}
              </p>
            </div>
            <div
              class="side1"
              *ngIf="
                item.paymentInfo[0]?.payment_status === 'refunded' &&
                item.paymentInfo[0]?.cancelled_trip_payment_info
                  ?.payment_type === 'Others-Refund'
              "
            >
              <h3>Manual Refund</h3>
              <p>
                ₹
                {{
                  (
                    item.paymentInfo[0]?.cancelled_trip_payment_info
                      ?.amount_paid || 0
                  ).toFixed(2)
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="paginationTrips">
    <div *ngIf="last_page && last_page > 1" class="pagination">
      <button
        class="btn"
        [disabled]="fetch_page == 1"
        (click)="pagination('-1')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <button
        class="btn"
        [disabled]="fetch_page == 1"
        (click)="pagination('first')"
      >
        <img
          src="../../../assets/img/pagination-left.svg"
          alt=""
          class="btn--icon"
        />
      </button>
      <div class="pages">
        <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
      </div>
      <button
        class="btn"
        [disabled]="last_page == fetch_page"
        (click)="pagination('last')"
      >
        <img
          src="../../../assets/img/pagination-right.svg"
          alt=""
          class="btn--icon"
        />
      </button>
      <button
        class="btn"
        [disabled]="last_page == fetch_page"
        (click)="pagination('1')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap=" round"
            stroke-linejoin="round"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  </div>
</div>
